import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';

const CuisineSections2 = (props) => {
    let Sections = props.sections.map((post, i)=>{
        return (
            <Link to={`/listing/s/${post.id}`} key={post.id} className="btn btn-outline-primary shadowed btn-sm mr-1">{post.name}</Link>
        );
    });

    return (
        <div className="section full mb-3">
            <div className="section-title"><br />Cuisines</div>
            <div className="wide-block" style={{'overflowY':'scroll', 'borderBottom': '0 none'}}>
                <div style={{'display': 'flex'}}>
                    <Link to='/listing' className="btn btn-outline-primary shadowed btn-sm mr-1">All</Link>
                    <Link to='/specialdish' className="btn btn-primary shadowed btn-sm mr-1">Speciality Dish</Link>
                    {Sections}
                </div>
            </div>
        </div>
    );
}
  
export default CuisineSections2;


// WEBPACK FOOTER //
// ./src/components/CuisineSections2.js